import { render, staticRenderFns } from "./bulk-edit.vue?vue&type=template&id=d5c7d8fa&scoped=true&"
import script from "./bulk-edit.vue?vue&type=script&lang=ts&"
export * from "./bulk-edit.vue?vue&type=script&lang=ts&"
import style0 from "./bulk-edit.vue?vue&type=style&index=0&id=d5c7d8fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c7d8fa",
  null
  
)

export default component.exports